(function ($) {
	// On Dom Ready
	$(function () {		
		// Toggle active class on active point
		$(".highlight-point").on({
			click: function (e) {
				e.preventDefault();
			},
			mouseenter: function () {
				$(".highlight-point").removeClass('active');
				$(this).addClass('active');
			},
			mouseleave: function () {
				$(".highlight-point").removeClass('active');
			}
		});

		// Close all points when an expanded point is clicked
		$(".highlight-image-circle").on('click', function () {
			$(".highlight-point").removeClass('active');
		});
	});
})(jQuery);
